import forecastingApi from '../api/forecastingApi'
import forecastingRepo from '../repos/forecastingRepo'
import publicHolidayRepo from '../repos/publicHolidayRepo'
import holidayApi from '../api/holidayApi'
import momentCache from "@/services/momentCache"

export default {
    async getPlantData(plantId){
        let plantData = null;

        try {
            plantData = await forecastingApi.getPlantData(
                plantId
            );

            await forecastingRepo.clearPlantData();
            await forecastingRepo.putPlantData(plantData);
        } catch (err) {
            console.log(err);
        }

        if(plantData == null){
            try {
                plantData = await forecastingRepo.getPlantData(
                    plantId
                );
            } catch (err) {
                console.log(err);
            }
        }

        return plantData;
    },
    async getFinancialYearCalendarsData() {
        let financialYearCalendarsData = null;

        try {
            financialYearCalendarsData = await forecastingApi.getFinancialYearCalendarsData();

            await forecastingRepo.clearFinancialYearCalendarsData();
            await forecastingRepo.putFinancialYearCalendarsData(financialYearCalendarsData);
        } catch (err) {
            console.log(err);
        }

        if(financialYearCalendarsData == null){
            try {
                financialYearCalendarsData = await forecastingRepo.getFinancialYearCalendarsData();
            } catch (err) {
                console.log(err);
            }
        }

        return financialYearCalendarsData;
    },
    async getNoteAlertCategories() {
        let noteAlertCategoryData = null;

        try {
            noteAlertCategoryData = await forecastingApi.getNoteAlertCategories();

            await forecastingRepo.clearNoteAlertCategoriesData();
            await forecastingRepo.putNoteAlertCategoriesData(noteAlertCategoryData);
        } catch (err) {
            console.log(err);
        }

        if(noteAlertCategoryData == null){
            try {
                noteAlertCategoryData = await forecastingRepo.getNoteAlertCategoriesData();
            } catch (err) {
                console.log(err);
            }
        }

        return noteAlertCategoryData;
    },
    async getWeatherData(plantId, startDate, endDate){
        let weatherData = null;

        try {
            weatherData = await forecastingApi.getWeatherData(
                plantId,
                startDate,
                endDate
            );

            await forecastingRepo.clearWeatherData();
            await forecastingRepo.putWeatherData(weatherData);
        } catch (err) {
            console.log(err);
        }

        if(weatherData == null){
            try {
                weatherData = await forecastingRepo.getWeatherData(
                    plantId,
                    startDate,
                    endDate
                );
            } catch (err) {
                console.log(err);
            }
        }

        return weatherData;
    },
    async getCropVarietyData(plantId, categoryId, startDate, endDate){
        let cropVarietyData = null;
        let saveDataPromise = null;

        try {
            cropVarietyData = await forecastingApi.getCropVarietyData(
                plantId,
                categoryId,
                startDate,
                endDate
            );

            // Since this takes a non-trivial amount of time but we don't
            // always need it immediately, do it in the background
            saveDataPromise = new Promise(async (resolve, reject) => {
                try {
                    await forecastingRepo.clearCrops();
                    await forecastingRepo.putCrops(cropVarietyData.crops);
                    await forecastingRepo.clearVarieties();
                    await forecastingRepo.putVarieties(cropVarietyData.varieties);
                    await forecastingRepo.clearForecasts();
                    await forecastingRepo.putForecasts(cropVarietyData.forecasts);
                    await forecastingRepo.clearNotes();
                    await forecastingRepo.putNotes(cropVarietyData.notes);
                    await forecastingRepo.clearNuPointSprays();
                    await forecastingRepo.putNuPointSprays(cropVarietyData.nuPointSprays)
                    resolve();
                } catch(err){
                    console.log(err);
                    reject(err);
                }
            });
        } catch (err) {
            console.log(err);
        }

        if(cropVarietyData == null){
            if(saveDataPromise != null){
                await saveDataPromise;
            }

            try {
                let crops = await forecastingRepo.getCrops(
                    plantId,
                    categoryId
                );

                let cropLocationIds = crops.map(x => x.cropLocationId);
                let locationIds = crops.map(x => x.locationId);

                cropVarietyData = {
                    crops,
                    varieties: await getCropVarieties(cropLocationIds),
                    forecasts: await getForecasts(
                        cropLocationIds,
                        startDate,
                        endDate
                    ),
                    yields: [],
                    notes: await getNotes(
                        cropLocationIds
                    ),
                    nuPointSprays: await forecastingRepo.getNuPointSprays(locationIds, startDate, endDate)
                }
            } catch (err) {
                console.log(err);
            }
        }

        return cropVarietyData;
    },    
    async getUnsentStatus(){
        let unsentStatus = {};

        try {
            unsentStatus.forecasts = await forecastingRepo.countUnsentForecasts();
            unsentStatus.notes = await forecastingRepo.countUnsyncedNotes();
            unsentStatus.varieties = await forecastingRepo.countUnsentCropVarieties();
        } catch (err) {
            console.log(err);
        }

        // TODO - Retrieve status for other unsent data types
        return unsentStatus;
    },
    async resendUnsent(){
        let promises = [];

        try {
            let unsentForecasts = await forecastingRepo.getAllUnsentForecasts();

            promises.push(this.updateForecasts(unsentForecasts));
            let unsyncedNotes = await forecastingRepo.getAllUnsyncedNotes();

            promises.push(...unsyncedNotes.map(async n => {
                await this.addUpdateNote(n);
            }));

            let unsetCropVarieties = await forecastingRepo.getAllUnsentCropVarieties();


            promises.push(...unsetCropVarieties.map(async c => {
                await this.updateCropVariety(c);
            }));
        } catch (err){
            console.log(err);
        }

        // TODO - Add promises for resending data for other unsent data types

        try {
            await Promise.all(promises);
        } catch (err) {
            console.log(err);
        }
    },
    async updateForecasts(forecastsToSend, fetchAll, plantId, categoryId, startDate, endDate){
        let forecasts = null;

        try {
            // Try and update the values in a single request
            forecasts = await forecastingApi.updateForecasts(forecastsToSend, fetchAll, plantId, categoryId, startDate, endDate);

            // Update existing values
            await forecastingRepo.putForecasts(forecasts);
           
            var unsentForecasts = await forecastingRepo.getAllUnsentForecasts();
            if (unsentForecasts.length > 0) {
                // Remove any matching unsent forecasts (which are now invalid)
                await Promise.all(forecastsToSend.map(async x => {
                    await forecastingRepo.removeUnsentForecast(x.cropLocationId, x.varietyId, x.forecastDate);
                }));
            }
        } catch (err){
            console.log(err);
        }

        // If we failed, go to fall backs
        if(forecasts == null){
            // Handle unsent individually
            forecasts = await Promise.all(forecastsToSend.map(async x => {
                // Record this as an unsent value
                await forecastingRepo.putUnsentForecast({
                    cropLocationId: x.cropLocationId,
                    varietyId: x.varietyId,
                    forecastDate: x.forecastDate,
                    forecastValue: x.forecastValue,
                    adjustedValue: x.adjustedValue
                });

                // Retrieve the latest value
                try {
                    return await getForecast(x.cropLocationId, x.varietyId, x.forecastDate);
                } catch (err){
                    console.log(err);
                }

                return null;
            }))
        }

        return forecasts;
    },
    async updateForecast(cropLocationId, varietyId, forecastDate, forecastValue, adjustedValue){
        let forecast = null;

        try {
            // Try and update the value
            forecast = await forecastingApi.updateForecast(
                cropLocationId,
                varietyId,
                forecastDate,
                forecastValue,
                adjustedValue
            );

            // Update existing values
            await forecastingRepo.putForecast(forecast);

            // Remove any matching unsent forecast (which is now invalid)
            await forecastingRepo.removeUnsentForecast(cropLocationId, varietyId, forecastDate);
        } catch (err) {
            console.log(err);
        }

        // If we failed, go to fall backs
        if(forecast == null){
            // Record this as an unsent value
            await forecastingRepo.putUnsentForecast({
                cropLocationId,
                varietyId,
                forecastDate,
                forecastValue,
                adjustedValue
            });

            // Retrieve the latest value
            try {
                forecast = await getForecast(cropLocationId, varietyId, forecastDate);
            } catch (err) {
                console.log(err);
            }
        }

        return forecast;
    },
    async updateCropVariety(varietyModel){
        let variety = null;

        try {
            // Try and update the value
            variety = await forecastingApi.updateCropVariety(varietyModel);

            // Update existing values
            await forecastingRepo.putVarieties([ variety ]);

            // Remove any matching unsent forecast (which is now invalid)
            await forecastingRepo.removeUnsentCropVariety(varietyModel.cropLocationId, varietyModel.varietyId);
        } catch (err) {
            console.log(err);
        }

        // If we failed, go to fall backs
        if(variety == null){
            // Record this as an unsent value
            await forecastingRepo.putUnsentCropVariety(varietyModel);

            // Retrieve the latest value
            try {
                variety = await getVariety(varietyModel.cropLocationId, varietyModel.varietyId);
            } catch (err) {
                console.log(err);
            }
        }

        return variety;
    },
    async addUpdateNote(note) {
        note.raisedAt = momentCache.getMoment(note.raisedAt).format();
        let notes = null;
        try {

            notes = await forecastingApi.addUpdateNotes([note]);
            await forecastingRepo.putNote(notes[0]);
            await forecastingRepo.removeUnsyncedNote(notes[0].cropLocationId, notes[0].varietyId, momentCache.getMoment(notes[0].raisedAt).format());
        } catch (err) {
            console.log(err);
        }
        // If we failed, go to fall backs
        if(notes == null){
            // Record this as an unsent value
            await forecastingRepo.putUnsyncedNote(note);

            // Retrieve the latest value
            try {
                note = await getNote(note.cropLocationId, note.varietyId, note.raisedAt);
            } catch (err) {
                console.log(err);
            }
            return note;
        } else {
            return notes[0];
        }
    },   
    async exportForecastReport(plantID, productCategoryID, divisionIds, varietyIds, startDate, endDate){
       var result = await forecastingApi.exportForecastReport(plantID, productCategoryID, divisionIds, varietyIds, startDate, endDate);
       let url = window.URL.createObjectURL(new Blob([result.data]));
       let link = document.createElement("a");
       link.href = url;
       let contentDisposition = result.headers["content-disposition"];
       let fileName = 'unknown';
       if(contentDisposition){
           let fileNameMatch = contentDisposition.match(/filename="(.+)"/);
           if(fileNameMatch.length === 2){
               fileName = fileNameMatch[1];
           }
       }
       link.setAttribute('download', fileName);
       document.body.appendChild(link);
       link.click();
       link.remove();
       window.URL.revokeObjectURL(url);
    }, 
    async getPublicHolidayData(selectedDate, selectedRegion) {
        var holidayData;
        try {
            var result = await holidayApi.getHolidays({selectedDate, selectedRegion})
            holidayData = result.map(h => ({
                Date: h.Date.substring(0,10),
                HolidayName: h.HolidayName,
                ID: h.ID,
                Regions: h.Regions
            }));
            await publicHolidayRepo.clearHolidays();
            await publicHolidayRepo.putHolidays(holidayData);
        } catch (err) {
            console.log(err);
        }
        if(holidayData == null){
            try {
                holidayData = await publicHolidayRepo.getHolidays();
            } catch (err) {
                console.log(err);
            }
        }
        return holidayData;
    }
}

// Retrieve the forecasts, but then apply the unsent forecasts on top
async function getForecasts(cropLocationId, startDate, endDate){    
    let forecasts = await forecastingRepo.getForecasts(cropLocationId, startDate, endDate);

    let unsentForecasts = await forecastingRepo.getUnsentForecasts(cropLocationId, startDate, endDate);
    for(let i = 0; i < unsentForecasts.length; i++){
        let unsentForecast = unsentForecasts[i];

        // Get the matching value
        let forecast = forecasts.find(x => 
            x.cropLocationId == unsentForecast.cropLocationId
            && x.varietyId == unsentForecast.varietyId 
            && x.forecastDate == unsentForecast.forecastDate
        );

        // If a matching value doesn't exist, create one
        if(forecast == null){
            forecast = {
                cropLocationId: unsentForecast.cropLocationId,
                varietyId: unsentForecast.varietyId,
                forecastDate: unsentForecast.forecastDate
            };
            forecasts.push(forecast);
        }

        // Apply the unsent values
        forecast.forecastValue = unsentForecast.forecastValue;
        forecast.adjustedValue = unsentForecast.adjustedValue;
    }

    return forecasts;
}


// Retrieve the forecast, but then apply a relevant unsent forecast on top
async function getForecast(cropLocationId, varietyId, forecastDate){
    let forecast = await forecastingRepo.getForecast(cropLocationId, varietyId, forecastDate);

    let unsentForecast = await forecastingRepo.getUnsentForecast(cropLocationId, varietyId, forecastDate);
    if(unsentForecast != null){
        // If a matching value doesn't exist, create one
        if(forecast == null){
            forecast = {
                cropLocationId,
                varietyId,
                forecastDate
            };
        }

        // Apply the unsent values
        forecast.forecastValue = unsentForecast.forecastValue;
        forecast.adjustedValue = unsentForecast.adjustedValue;
    }

    return forecast;
}

// Retrieve the notes, but then apply the unsynced notes on the top
async function getNotes(cropLocationIds){
    let notes = await forecastingRepo.getNotes(cropLocationIds);

    let unsyncedNotes = await forecastingRepo.getUnsyncedNotes(cropLocationIds);
    for(let i = 0; i < unsyncedNotes.length; i++){
        let unsyncedNote = unsyncedNotes[i];

        // Get the matching value
        let note = notes.find(x => 
            x.varietyId == unsyncedNote.varietyId 
            && x.raisedAt == unsyncedNote.raisedAt
        );

        // If a matching value doesn't exist, create one
        if(note == null){
            note = {
                cropLocationId: unsyncedNote.cropLocationId,
                varietyId: unsyncedNote.varietyId,
                raisedAt: unsyncedNote.raisedAt
            };
            notes.push(note);
        }

      
        // Apply the values
        note.raisedBy = unsyncedNote.raisedBy;
        note.raisedByName = unsyncedNote.raisedByName;
        note.closedBy = unsyncedNote.closedBy;
        note.closedAt = unsyncedNote.closedAt;
        note.closedByName = unsyncedNote.closedByName;
        note.berriesForecastNoteAlertCategoryId = unsyncedNote.berriesForecastNoteAlertCategoryId;
        note.categoryName = unsyncedNote.categoryName;
        note.alertLevel = unsyncedNote.alertLevel;
        note.photos = unsyncedNote.photos;
        note.comments = unsyncedNote.comments;
        note.details = unsyncedNote.details;
        note.isClosed = unsyncedNote.isClosed;
    }

    return notes;
}

/**
 * Get note, if there is unasynced note, put it on the top
 * @param {*} cropLocationId 
 * @param {*} varietyId 
 * @param {*} raisedAt 
 */
async function getNote(cropLocationId, varietyId, raisedAt){
    raisedAt = momentCache.getMoment(raisedAt).format();
    let note = await forecastingRepo.getNote(cropLocationId, varietyId, raisedAt);

    let unsyncedNote = await forecastingRepo.getUnsyncedNote(cropLocationId, varietyId, raisedAt);
    if(unsyncedNote != null){
        // If a matching value doesn't exist, create one
        if(note == null){
            note = {
                cropLocationId,
                varietyId,
                raisedAt
            };
        }

        // Apply the values
        note.raisedBy = unsyncedNote.raisedBy;
        note.raisedByName = unsyncedNote.raisedByName;
        note.closedBy = unsyncedNote.closedBy;
        note.closedAt = unsyncedNote.closedAt;
        note.closedByName = unsyncedNote.closedByName;
        note.berriesForecastNoteAlertCategoryId = unsyncedNote.berriesForecastNoteAlertCategoryId;
        note.categoryName = unsyncedNote.categoryName;
        note.alertLevel = unsyncedNote.alertLevel;
        note.photos = unsyncedNote.photos;
        note.comments = unsyncedNote.comments;
        note.details = unsyncedNote.details;
        note.isClosed = unsyncedNote.isClosed;
    }

    return note;
}

// Retrieve the varieties, but then apply the unsent ones on top
async function getCropVarieties(cropLocationIds){
    let varieties = await forecastingRepo.getVarieties(
        cropLocationIds
    )

    let unsentVarieties = await forecastingRepo.getUnsentCropVarieties(cropLocationIds);
    for(let i = 0; i < unsentVarieties.length; i++){
        let unsentCropVariety = unsentVarieties[i];

        // Get the matching value
        let variety = varieties.find(x => 
            x.varietyId == unsentCropVariety.varietyId
        );

        // If a matching value doesn't exist, create one
        if(variety == null){
            varieties.push(unsentCropVariety);
        } 
        else {
            const index = this.varieties.indexOf(variety)
            varieties.splice(index, 1, unsentCropVariety);
        }
    }

    return varieties;
}

async function getVariety(cropLocationId, varietyId) {
    let unsent = await forecastingRepo.getUnsentCropVariety(cropLocationId, varietyId);

    if (unsent) {
        return unsent;
    }

    return await forecastingRepo.getCropVariety(cropLocationId, varietyId);
}
